import React, { useState } from "react";
import { useFirebase } from "../../database/FirebaseContext";
import { getLocalUser, setLocalUser } from "../../database/localStorage";

function ResetPasswordForm({ onClose }) {
	const { updateUserPassword } = useFirebase();
	const [formPassword, setFormPassword] = useState({
		newPassword: "",
		confirmPassword: "",
	});
	const [passwordsMatch, setPasswordsMatch] = useState(true); // Track if passwords match

	const handleEvent = (event) => {
		const { name, value } = event.target;
		setFormPassword((prevPassword) => ({
			...prevPassword,
			[name]: value,
		}));
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		// Check if the passwords match
		if (formPassword.newPassword === formPassword.confirmPassword) {
			// Passwords match, handle the password change
			setPasswordsMatch(true);

			// use the function for updating the password (from firebase context)
			const userData = getLocalUser();
			updateUserPassword(userData, formPassword.newPassword);
			setLocalUser({
				...userData,
				userPassword: formPassword.newPassword,
			});
		} else {
			// Passwords don't match, set the error state
			setPasswordsMatch(false);
		}
	};

	return (
		<div className="fixed block z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] top-0 left-0">
			<div className="flex justify-center items-center z-40 relative pt-[250px]">
				<div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
					{/* Header for Form */}
					<div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
						Change Password
					</div>
					{/* Form */}
					<form onSubmit={handleSubmit}>
						<div className="bg-[#3D3E44] rounded-b-xl">
							<div className="bg-modalbg flex mt-[35px]">
								<div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[50px]">
									<label
										htmlFor="newPassword"
										style={{ width: "150px" }}
									>
										<p className="text-[14px]">
											New Password
										</p>
									</label>
								</div>
								<div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
									<input
										className="pl-[5px] text-[12px] bg-fieldbg w-full text-black"
										type="text"
										id="newPassword"
										name="newPassword"
										value={formPassword.newPassword}
										onChange={handleEvent}
										required
									/>
								</div>
							</div>

							<div className="bg-modalbg flex mt-[20px]">
								<div className="bg-modalbg flex justify-end items-center mr-[10px] pl-[50px]">
									<label
										htmlFor="confirmPassword"
										style={{ width: "150px" }}
									>
										<p className="text-[14px]">
											Confirm Password
										</p>
									</label>
								</div>
								<div className="bg-fieldbg flex shrink-10 items-center w-full mr-[15px]">
									<input
										className="pl-[5px] text-[12px] bg-fieldbg w-full text-black"
										type="text"
										id="confirmPassword"
										name="confirmPassword"
										value={formPassword.confirmPassword}
										onChange={handleEvent}
										required
									/>
								</div>
							</div>

							{/* Error message for password mismatch */}
							{!passwordsMatch && (
								<div className="text-red-600 text-center mt-3">
									Passwords do not match. Please try again.
								</div>
							)}

							{/* Buttons */}
							<div className="bg-modalbg flex mt-[25px] justify-center mb-[20px]">
								<div className="space-x-5">
									<button
										type="submit"
										value="changePassword"
										className="bg-[#616675] pl-[12px] pr-[12px]"
									>
										SAVE
									</button>
									<button
										className="bg-[#616675] pl-[12px] pr-[12px]"
										onClick={onClose}
									>
										CLOSE
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}

export default ResetPasswordForm;
